import * as React from "react";
import { toastr } from "react-redux-toastr";
import { cloneDeep } from "lodash";
import VisualSearchService from "src/share/services/visualSearch";
import { validateImage } from "src/share/utils/fileHandler";
import { initialVisualSearchState, By, VisualSearchActions } from "src/share/types/visualSearch";
import visualSearchReducer from "../state/reducer";

export const useBingSearch = () => {
  const [state, dispatch] = React.useReducer(visualSearchReducer, cloneDeep(initialVisualSearchState));
  async function fetchImages(image, by: By) {
    if (by === By.Base64 && !validateImage(image, 1.2)) {
      dispatch({ type: VisualSearchActions.error, payload: "Image size exceeded." });
      toastr.error(state.error, "The uploaded image is too big.");
      return;
    }
    try {
      dispatch({ type: VisualSearchActions.setLoading });
      const response = await VisualSearchService.bingSearch(image, by);
      if(!response.data.payload.length) {
        return dispatch({ type: VisualSearchActions.error, payload: "Sorry, we couldn't find any results." });
      }
      dispatch({ type: VisualSearchActions.setImages, payload: response.data.payload });
    } catch (err) {
      dispatch({ type: VisualSearchActions.error, payload: err.payload });
      toastr.error("Error", "The given image couldn't be processed.");
    }
  }
  return {
    state,
    actions: { dispatch, fetchImages }
  };
};
